import { cn } from "../../lib/utils";
import { Link } from "react-router-dom";

export function NavItem({ href, icon, children, isActive, external }) {
  const linkProps = {
    className: cn(
      "flex items-center gap-3 rounded-lg px-3 py-2 transition-all hover:bg-accent/40",
      isActive ? "text-[#ffa300] font-semibold" : "text-[#64748B]"
    )
  };

  return external ? (
    <a 
      href={href}
      {...linkProps}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span className={cn("flex-shrink-0", isActive ? "text-[#ffa300]" : "text-[#64748B]")}>
        {icon}
      </span>
      <span className="text-sm font-medium">{children}</span>
    </a>
  ) : (
    <Link 
      to={href}
      {...linkProps}
    >
      <span className={cn("flex-shrink-0", isActive ? "text-[#ffa300]" : "text-[#64748B]")}>
        {icon}
      </span>
      <span className="text-sm font-medium">{children}</span>
    </Link>
  );
}
